module.exports = __webpack_public_path__ + "static/media/YM57_1.f7f837f1.jpg";